import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 756.26 596.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M743.96 245.25c-18.54-12.48-67.26-17.81-102.68-8.27-1.91-35.28-20.1-65.01-53.38-90.95l-12.32-8.27-8.21 12.4c-16.14 24.5-22.94 57.14-20.53 86.81 1.9 18.28 8.26 38.83 20.53 53.74-46.1 26.74-88.59 20.67-276.77 20.67H.06c-.85 42.49 5.98 124.23 57.96 190.77 5.74 7.35 12.04 14.46 18.87 21.31 42.26 42.32 106.11 73.35 201.59 73.44 145.66.13 270.46-78.6 346.37-268.97 24.98.41 90.92 4.48 123.19-57.88.79-1.05 8.21-16.54 8.21-16.54l-12.3-8.27Zm-554.29-38.86h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm-422.2 0H2.42v81.7h81.7zM189.67 103.2h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm105.55 0h-81.7v81.7h81.7zm0-103.2h-81.7v81.7h81.7z",
      style: {"fill":"#1d63ed","stroke-width":"0"}
    }, null, -1)
  ])))
}
export default { render: render }